import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BrandEquityOptions } from '@infrab4a/connect';
import { NgxPermissionsService } from 'ngx-permissions';
import { DropdownFilter, TableColumn } from 'src/app/components/table';
import { ShopCategoryService } from 'src/app/connect-api/api/shop/shop-category.service';
import { Role, roleAsObject } from 'src/app/models';

@Component({
  selector: 'app-shop-categories',
  templateUrl: './shop-categories.component.html',
  styleUrl: './shop-categories.component.scss'
})
export class ShopCategoriesComponent implements OnInit {
  cols = [
    new TableColumn(
      'Id',
      'id',
      true,
      'text',
      'category/',
      'id',
      true,
      'equals'
    ),
    new TableColumn(
      'Nome',
      'name',
      true,
      'text',
      'category/',
      'id',
      true,
      'contains'
    ),
    new TableColumn(
      'Loja',
      'shops',
      true,
      'text',
      undefined,
      undefined,
      undefined,
      'in'
    ),
    new TableColumn(
      'É uma marca',
      'brandCategory',
      true,
      'boolean',
      undefined,
      undefined
    ),
    new TableColumn(
      'É uma coleção',
      'isCollection',
      true,
      'boolean',
      undefined,
      undefined
    ),
    new TableColumn(
      'É uma Wishlist',
      'isWishlist',
      true,
      'boolean',
      undefined,
      undefined
    ),
    new TableColumn.Builder()
      .setHeader('Valor da marca')
      .setField('brandEquity')
      .setFilter(true)
      .setType('text')
      .setShowMobile(true)
      .setCondition('equals')
      .setDisplayFunction((item) => this.getBrandEquityLabel(item.brandEquity))
      .build(),
    new TableColumn(
      'Referência',
      'reference',
      true,
      'text',
      undefined,
      undefined,
      true,
      'contains'
    ),
    new TableColumn(
      'Ativo',
      'published',
      true,
      'boolean',
      undefined,
      undefined,
      true
    )
  ];
  brandEquityOptions = Object.keys(BrandEquityOptions).map((key) => ({
    label: key
      .split('_')
      .map(
        (word) =>
          word.charAt(0).toUpperCase() + word.slice(1).toLocaleLowerCase()
      )
      .join('. '),
    value: BrandEquityOptions[key]
  }));

  dropdownFilters: {
    [field: string]: Array<DropdownFilter>;
  } = {
    shops: [
      { label: 'Todos', value: '' },
      { label: 'Glamshop', value: 'Glamshop' },
      { label: 'Men`s Market', value: 'mensmarket' }
    ],
    brandCategory: [
      { label: 'Todos', value: undefined },
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ],
    isCollection: [
      { label: 'Todos', value: undefined },
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ],
    isWishlist: [
      { label: 'Todos', value: undefined },
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ],
    brandEquity: this.brandEquityOptions,
    published: [
      { label: 'Todos', value: undefined },
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  };

  private permissionsService = inject(NgxPermissionsService);

  defaultFilterValues = { isWishlist: false };
  permission = false;

  constructor(
    private title: Title,
    protected shoppingCategoryService: ShopCategoryService
  ) {
    this.title.setTitle('Loja - Categorias');
  }

  async ngOnInit(): Promise<void> {
    this.permission = await this.permissionsService.hasPermission([
      roleAsObject(Role.Full_Administrator).enumValue,
      roleAsObject(Role.Portfolio).enumValue
    ]);
  }

  getBrandEquityLabel(value: string): string {
    return (
      this.brandEquityOptions.find((option) => option.value === value)?.label ||
      value ||
      ''
    );
  }
}
